import { Accordion } from "@mui/material";
import { styled } from "@mui/system";

const AccordionCustoms = styled(Accordion)(({ theme }) => ({
  boxShadow: "none",
  "&::before": {
    opacity: 0,
  },
  // "&::after": {
  //   position: 'absolute',
  //   left: 0,
  //   bottom: `-1px`,
  //   right: 0,
  //   height: `1px`,
  //   content: '""',
  //   opacity: 1,
  //   backgroundColor: theme.palette.divider,
  //   transition: `opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
  // },
}));
export default AccordionCustoms;
